import { useNavigate } from "react-router-dom"
import { postAnnouncement } from "../../api/announcements"
import { useAuth } from "../../App"
import { Divider } from "../misc"
import { FormEvent } from "react"
import { GenericFormBGContainer, GenericInput, GenericTextArea } from "../GenericForm"
import { GenericForm } from "../GenericForm"
import { BottomFormButton } from "../Buttons"

/**
 * ### Route for ('/announcements/create')
 * 
 * Creates an announcement
 * 
 * TODO: Should be a manager or admin
 * TODO: Need to automatically delete after a certain amount of time
 */
export function SetAnnouncement() {
    const { user } = useAuth()
    const navigate = useNavigate()

    const handleSubmit = async(event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const formData = new FormData(event.currentTarget)
        const title = formData.get("title")
        const content = formData.get("content")
        const author = user?.email
        const duration = Number(formData.get("duration"))

        const data = {
            title: title as string,
            content: content as string,
            author: author as string,
            duration: duration as number
        }

        const response = await postAnnouncement(data)
        if (response.operation === "COMPLETED") {
            alert("Announcement created successfully!")
            navigate("/main_menu")
        } else {
            alert("Error: " + response.message)
        }
    }
    return (
        <>
            <AnnouncementForm handleSubmit={handleSubmit}/>
        </>
    )
}

function AnnouncementForm({handleSubmit}: {handleSubmit: (event: FormEvent<HTMLFormElement>) => void}) {
    return (
        <GenericForm form_id="announcement_creation" onSubmit={handleSubmit}>
            <GenericFormBGContainer>
                <h2 className="text-2xl font-bold">Create Announcement</h2>

                <Divider />

                <GenericInput label="Title" name="title" type="text" />
                <GenericTextArea label="Content" name="content"/>

                <label htmlFor="duration">Duration</label>
                <select name="duration" className="p-2 bg-white border border-gray-400 rounded-xl focus:outline-none focus:ring focus:ring-orange-400">
                    {/* The VALUES are in seconds */}
                    <option value={43200}>12 Hours</option>
                    <option value={86400}>1 Day</option>
                    <option value={604800}>1 Week</option>
                </select>

                <BottomFormButton button_text="Create Announcement"/>
            </GenericFormBGContainer>
        </GenericForm>
    )
}
